import { Box, InputLabel, Slider, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FC } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { BotContentTextField } from '@/components/custom-form-text-field';
import { YesNoConfirmationBotModuleData } from '@/domain/bot';
import { NodeFormProps } from '@/domain/node-form-props';
import { useSaveBotVersionEnabled } from 'utils/hooks/use-save-bot-version-enabled';

export const FallbackBlock: FC<
    NodeFormProps<YesNoConfirmationBotModuleData['params']>
> = ({ control }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const saveEnabled = useSaveBotVersionEnabled();

    return (
        <Box
            sx={{
                border: `solid 3px ${theme.palette.secondary.veryLight}`,
                borderRadius: '10px',
                p: 2,
                marginBottom: '1rem',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                }}
            >
                <Typography variant='cardTitle'>
                    {t('prompt_fallback')}
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
                <Box sx={{ width: '100%' }}>
                    <InputLabel className='input-label-card'>
                        {t('fallback_response')}
                    </InputLabel>
                    <Controller
                        name='prompt_fallback'
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                            <BotContentTextField
                                {...field}
                                fieldError={error}
                                placeholder={
                                    t('you_will_override_default') as string
                                }
                                fullWidth
                                autoResize
                                disabled={!saveEnabled}
                            />
                        )}
                    />

                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <div
                            className='node-section-port-indication'
                            style={{ backgroundColor: 'grey' }}
                        />
                    </Box>
                </Box>
                <Box sx={{ width: '100%' }}>
                    <InputLabel className='input-label-card'>
                        {t('number_retries_question')}
                    </InputLabel>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            height: '50px',
                        }}
                    >
                        <Controller
                            name='number_of_retries'
                            control={control}
                            render={({ field }) => (
                                <Slider
                                    {...field}
                                    min={0}
                                    max={4}
                                    valueLabelDisplay='auto'
                                    disabled={!saveEnabled}
                                />
                            )}
                        />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};
